





















































































































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {InputResponsavelGrupoParceiroSchema} from '@/schema/resource/ResponsavelGrupoParceiro/InputResponsavelGrupoParceiroSchema'
import {FaturamentoConfiguracao} from '@/model/resource/FaturamentoConfiguracao'
import ModalExportReport from '@/components/modals/ModalExportReport.vue'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelGrupoParceiro} from '@/model/resource/ResponsavelGrupoParceiro'
import {ResponsavelGrupoParceiroFilterCollection} from '@/model/filter/ResponsavelGrupoParceiroFilterCollection'

@Component({
  components: {ModalExportReport},
})
export default class PersistResponsavelGrupoParceiroView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelGrupoParceiroSchema()
  faturamento = new FaturamentoConfiguracao()
  responsavel = new Responsavel()
  parceiros = new ResponsavelGrupoParceiroFilterCollection()
  grupoParceiro = new ResponsavelGrupoParceiro()

  addNew = false

  async created() {
    await this.populateResource()
    //await this.populate()
    await this.applyFilterCollection()
  }

  toggleAddNew() {
    this.addNew = !this.addNew
  }

  async applyFilterCollection() {
    this.parceiros.id = this.id ?? null
    await $.await.run('listIdsGrupoParceiro', () =>
      this.parceiros.listIdsGrupoParceiro()
    )
  }

  async removeResponsavel(resp: ResponsavelGrupoParceiro) {
    const idMaster = resp.idResponsavelMasterFk
    const idPermitido = resp.idResponsavelParceiroFk
    if (idMaster && idPermitido) {
      await this.parceiros.removeResponsavelGrupoParceiro(idMaster, idPermitido)
      this.$snotify.success(this.$t('system.success.persist') as string)
      await this.applyFilterCollection()
      this.$forceUpdate()
    }
  }

  async populateResource() {
    const id = Number(this.id) || null
    if (id) {
      await this.responsavel.getResponsavel(id)
    }
    $.await.done('getResponsavel')
  }

  @Watch('grupoParceiro.parceiroPermitido')
  async populate() {
    const idParceiroPermitido = this.grupoParceiro?.parceiroPermitido?.$id
    if (idParceiroPermitido) {
      const resp = this.grupoParceiro.parceiroPermitido?.getResponsavel(
        idParceiroPermitido
      )
      if (!resp) {
        this.grupoParceiro.reset()
      } else {
        this.grupoParceiro.idResponsavelParceiroFk = idParceiroPermitido
        this.grupoParceiro.idResponsavelMasterFk = this.responsavel.idResponsavelPk
      }
    } else {
      this.grupoParceiro.reset()
    }
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (
      !isValid ||
      this.grupoParceiro.idResponsavelMasterFk == 0 ||
      this.grupoParceiro.idResponsavelParceiroFk == 0
    ) {
      Helper.abort('system.error.validation')
    }

    await this.grupoParceiro.persistResponsavelGrupoParceiro()
    this.$snotify.success(this.$t('system.success.persist') as string)
    $.await.done('persistResponsavelGrupoParceiro')
    this.grupoParceiro.reset()
    this.addNew = false
    await this.applyFilterCollection()
    this.$forceUpdate()
  }
}
